import { AfterContentInit, Directive, EventEmitter, Input, Output } from '@angular/core';
import { McticHttpClient, Page } from '@mctic/ng-core';

@Directive({
  selector: '[appResource]'
})
export class ResourceDirective implements AfterContentInit {

  private _resource: string;

  @Input()
  private appResourceValue: object[];

  @Output()
  private readonly appResourceValueChange = new EventEmitter();

  constructor(private readonly http: McticHttpClient) {
  }

  ngAfterContentInit(): void {
    this.http.get<any[]>(this._resource).subscribe((value: any) => {
      if (value instanceof Page) {
        this.appResourceValue = value.content;
        this.appResourceValueChange.emit(value.content);
      } else {
        this.appResourceValue = value;
        this.appResourceValueChange.emit(value);
      }
    });
  }

  @Input()
  set appResource(resource: string) {
    if (resource.indexOf('/rest') === -1) {
      resource = '/rest' + resource;
    }

    if (resource.indexOf('/sepin-backend') === -1) {
      resource = '/sepin-backend' + resource;
    }

    this._resource = resource;
  }
}
